import ProductFinancialInsights from "./products/ProductFinancialInsights";
import ProductTaxFiling from "./products/ProductTaxFiling";

function ProductEcosystem({ content }) {
  return (
    <div className="product-ecosytem-container">
      <ProductFinancialInsights content={content?.financial_insights} />
      <ProductTaxFiling content={content?.tax_filing} />
    </div>
  );
}

export default ProductEcosystem;
